var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-max-w-2xl tw-grid tw-grid-cols-1 sm:tw-grid-cols-6 tw-gap-x-6 tw-gap-y-8"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }